import { LIST_FISCAL_DOCUMENTS } from '@/data/actions/modules/financial';

export default [
  {
    path: '/financial/fiscal-documents',
    component: () => import(/* webpackChunkName: "fiscalDocuments" */ './components/Main.vue'),
    meta: {
      layout: 'master',
      requiresAuth: true,
      permission: LIST_FISCAL_DOCUMENTS,
    },
  },
];
